import React from "react"
import Figures from "./figures"
import { graphql, useStaticQuery } from "gatsby"

const figs = [
  {
    _typename: "thumbnail",
    reference: "1",
    image: "T01",
    size: 2,
    caption_en: {
      body: "<em>Anne Savage at her desk at Baron Byng</em>, c. 1940, Anne Savage Fonds, Concordia University Archives, file P146-06-01.7.",
    },
    caption_fr: {
      body:
        "<em>Anne Savage </em>à son bureau à<em> Baron Byng</em>, vers 1940, Fonds Anne Savage, Archives de l’Université Concordia, document P146-06-01.7.",
    },
  },
  {
    _typename: "gallery-sketchbook",
    reference: ["2", "2.1", "2.2"],
    images: ["T02_1", "T02_2"],
    size: 1,
    caption_en: [
      {
        body: "CBC Lectures on <em>The Development of Art in Canada</em>",
      },
      {
        body: "“First Talk on Canadian Art Series” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.1.",
      },
      {
        body: "“First Talk on Canadian Art Series” (final version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.2.",
      },
    ],
    caption_fr: [
      {
        body:
          "Conférences radiophoniques&#160;<em>The Development of Art in Canada</em>",
      },
      {
        body:
          "«&#160;First Talk on Canadian Art Series&#160;»&#160;(version originale annotée),<em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.1.",
      },
      {
        body:
          "«&#160;First Talk on Canadian Art Series&#160;»&#160;(version finale), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.2.",
      },
    ],
  },
  {
    _typename: "gallery-sketchbook",
    reference: ["2.3", "2.4"],
    images: ["T02_3", "T02_4"],
    size: 1,
    caption_en: [
      {
        body: "“Paul Kane” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.3.",
      },
      {
        body: "“Paul Kane” (final version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.4.",
      },
    ],
    caption_fr: [
      {
        body:
          "«&#160;Paul Kane&#160;»&#160;(version originale annotée), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.3.",
      },
      {
        body:
          "«&#160;Paul Kane&#160;»&#160;(version finale), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.4.",
      },
    ]
  },
  {
    _typename: "gallery-sketchbook",
    reference: ["2.5", "2.6"],
    images: ["T02_5", "T02_6"],
    size: 1,
    caption_en: [
      {
        body: "“Cornelius Krieghoff” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.5.",
      },
      {
        body: "“Cornelius Krieghoff” (final version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.6.",
      },
    ],
    caption_fr: [
      {
        body:
          "«&#160;Cornelius Krieghoff&#160;»&#160;(version originale annotée), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.5.",
      },
      {
        body:
          "«&#160;Cornelius Krieghoff&#160;»&#160;(version finale), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.6.",
      },
    ],
  },
  {
    _typename: "gallery-sketchbook",
    reference: ["2.7", "2.8"],
    images: ["T02_7", "T02_8"],
    size: 1,
    caption_en: [
      {
        body: "“J.&nbsp;W.&nbsp;Morrice” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.7.",
      },
      {
        body: "“J.&nbsp;W.&nbsp;Morrice” (final version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.9.",
      },
    ],
    caption_fr: [
      {
        body:
          "«&#160;J.&nbsp;W.&nbsp;Morrice&#160;» (version originale annotée), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.7.",
      },
      {
        body:
          "«&#160;J.&nbsp;W.&nbsp;Morrice&#160;» (version finale), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.9.",
      },
    ],
  },
  {
    _typename: "gallery-sketchbook",
    reference: ["2.9", "2.10"],
    images: ["T02_9", "T02_10"],
    size: 1,
    caption_en: [
      {
        body: "“Tom Thompson” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.10.",
      },
      {
        body: "“Tom Thompson” (final version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.11.",
      },
    ],
    caption_fr: [
      {
        body:
          "«&#160;Tom Thompson&#160;» (version originale annotée), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.10.",
      },
      {
        body:
          "«&#160;Tom Thompson&#160;» (version finale), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.11.",
      },
    ],
  },
  {
    _typename: "gallery-sketchbook",
    reference: ["2.11", "2.12"],
    images: ["T02_11", "T02_12"],
    size: 1,
    caption_en: [
      {
        body: "“MacDonald and Harris” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.12.",
      },
      {
        body: "“MacDonald and Harris” (final version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.13.",
      },
    ],
    caption_fr: [
      {
        body:
          "«&#160;MacDonald and Harris&#160;»&#160;(version originale annotée), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.12.",
      },
      {
        body:
          "«&#160;MacDonald and Harris&#160;»&#160;(version finale), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.13.",
      },
    ],
  },
  {
    _typename: "gallery-sketchbook",
    reference: ["2.13", "2.14"],
    images: ["T02_13", "T02_14"],
    size: 1,
    caption_en: [
      {
        body: "“A. Y. Jackson and Arthur Lismer” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.14.",
      },
      {
        body: "“A. Y. Jackson and Arthur Lismer” (final version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.15.",
      },
    ],
    caption_fr: [
      {
        body:
          "«&#160;A. Y. Jackson and Arthur Lismer&#160;»&#160;(version originale annotée), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.14.",
      },
      {
        body:
          "«&#160;A. Y. Jackson and Arthur Lismer&#160;»&#160;(version finale), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.15.",
      },
    ],
  },
  {
    _typename: "gallery-sketchbook",
    reference: ["2.15", "2.16"],
    images: ["T02_15", "T02_16"],
    size: 1,
    caption_en: [
      {
        body: "“The Conclusion of Canadian Art Series” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.16.",
      },
      {
        body: "“The Conclusion of Canadian Art Series” (final version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.17.",
      },
    ],
    caption_fr: [
      {
        body:
          "«&#160;The Conclusion of Canadian Art Series&#160;»&#160;(version originale annotée), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.16.",
      },
      {
        body:
          "«&#160;The Conclusion of Canadian Art Series&#160;»&#160;(version finale), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.17.",
      },
    ],
  },
  {
    _typename: "sketchbook",
    reference: "3",
    images: "T03",
    size: 5,
    caption_en: {
      body: "“First Talk on Canadian Art Series” (original annotated version), <em>The Development of Art in Canada</em>, 1939, Anne Savage Fonds, Concordia University Archives, file 2.1 (detail), 6-8.",
    },
    caption_fr: {
      body:
        "«&#160;First Talk on Canadian Art Series&#160;»&#160;(version originale annotée), <em>The Development of Art in Canada</em>, 1939, Fonds Anne Savage, Archives de l’Université Concordia, document 2.1&#160;(detail), p. 6-8.",
    },
  },
  {
    _typename: "sketchbook",
    reference: "4",
    images: "T04",
    size: 7,
    caption_en: {
      body: "<em>Some Women Painters of Canada</em>, n.d., Anne Savage Fonds, Concordia University Archives, file 2.20.",
    },
    caption_fr: {
      body:
        "Anne Savage, <em>Some Women Painters of Canada</em>,&#160;n.&#160;d., Fonds Anne Savage, Archives de l’Université Concordia, document 2.20.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "5",
    image: "T05",
    size: 2,
    caption_en: {
      body: "Emily Carr<br /><em>Spring Time</em>, 1938-1939<br />Oil on paper mounted on panel<br />61 x 91,4 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of Max Stern, 1986<br />Photo: Denis Farley",
    },
    caption_fr: {
      body:
        "Emily Carr<br /><em>Spring Time</em>, 1938-1939<br />Huile sur papier marouflé sur panneau<br />61 x 91,4 cm",
      source: "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don de Max Stern, 1986<br />Photo&#160;: Denis Farley",
    },
  },
  {
    _typename: "thumbnail",
    reference: "6",
    image: "T06",
    size: 4,
    caption_en: {
      body: "Prudence Heward<br /><em>Girl on a Hill</em>, 1928<br />Oil on canvas<br />101,8 x 94,6 cm",
      source: "National Gallery of Canada, Ottawa<br />Photo: NGC, Ottawa",
    },
    caption_fr: {
      body:
        "Prudence Heward<br /><em>Femme sur une colline</em>, 1928<br />Huile sur toile<br />101,8 x 94,6 cm",
      source: "Musée des beaux-arts du Canada, Ottawa<br />Photo: MBAC",
    },
  },
  {
    _typename: "thumbnail",
    reference: "7",
    image: "T07",
    size: 5,
    caption_en: {
      body: "Emily Carr, <em>Klee Wyck</em>, Oxford University Press, 1941. Cover of the first edition featuring <em>Indian Village, Alert Bay</em>, 1912.",
    },
    caption_fr: {
      body:
        "Emily Carr, <em>Klee Wyck</em>, Oxford University Press, 1941. Page couverture de la première édition avec une reproduction de <em>Indian Village, Alert Bay</em>, 1912.",
    },
  },
  {
    _typename: "sketchbook",
    reference: "8",
    images: "T08",
    size: 5,
    caption_en: {
      body: "<em>Undated notes for a lecture on “The Art Profession,”</em> n.d., Anne Savage Fonds, Concordia University Archives, file 2.35.",
    },
    caption_fr: {
      body:
        "<em>Undated notes for a lecture on </em>«&#160;<em>The Art Profession</em>&#160;»,&#160;n.&#160;d., Fonds Anne Savage, Archives de l’Université Concordia, document 2.35.<br />",
    },
  },
]

export default ({ size }) => {
  const data = useStaticQuery(query)

  return <Figures data={data} figures={figs} pre="transmettre" size={size} />
}

export const query = graphql`
  query {
    T01: file(relativePath: { eq: "transmettre/T_01.jpg" }) {
      ...thumbnailImage
    }
    T02_1: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.1\//" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_2: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.2/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_3: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.3/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }

    T02_4: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.4/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_5: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.5/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_6: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.6/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_7: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.7/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_8: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.8/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_9: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.9/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_10: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.10/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_11: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.11/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_12: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.12/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_13: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.13/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_14: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.14/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_15: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.15/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T02_16: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_2.16/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T03: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_03/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T04: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_04/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    T05: file(relativePath: { eq: "transmettre/T_05.jpg" }) {
      ...thumbnailImage
    }
    T06: file(relativePath: { eq: "transmettre/T_06.jpg" }) {
      ...thumbnailImage
    }
    T07: file(relativePath: { eq: "transmettre/T_07.jpg" }) {
      ...thumbnailImage
    }
    T08: allFile(
      filter: {
        relativePath: { regex: "/^transmettre/T_08/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
  }
`
